import { render, staticRenderFns } from "./ImsProfitLossAddOrEditTraderModal.vue?vue&type=template&id=483d164e&"
import script from "./ImsProfitLossAddOrEditTraderModal.vue?vue&type=script&lang=js&"
export * from "./ImsProfitLossAddOrEditTraderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports